import {maybe, fromMaybe} from '@freckle/maybe'
import {getEnvironment} from '@freckle/educator-entities/ts/config/environment'
import {CONTENT_URL} from './env'

const hostname = window.location.hostname

// everything AFTER student or teacher in the domain name
const urlRegex =
  /(localhost|((classroom|student|school|console|sso)((.*)\.(freckle|freckletest|localhost).com)))/
const defaultValue = ''
const fullSuffix = maybe(
  () => defaultValue,
  regexMatch => fromMaybe(() => defaultValue, regexMatch[4]),
  urlRegex.exec(hostname)
)

const landingUrl = `https://www${fullSuffix}`

export const mkSubdomainUrl = (subdomain: string): string => {
  const protocol = 'https'
  const {hostname} = window.location
  if (hostname === 'localhost') {
    return `${protocol}://${subdomain}.localhost.com`
  } else {
    const defaultSuffix = '.localhost.com'
    const fullSuffix = maybe(
      () => defaultSuffix,
      regexMatch => fromMaybe(() => defaultSuffix, regexMatch[4]),
      urlRegex.exec(hostname)
    )
    return `${protocol}://${subdomain}${fullSuffix}`
  }
}

const mkLaunchControlBaseUrl = () => {
  const environment = getEnvironment(window.location.hostname)

  switch (environment) {
    case 'production':
    case 'staging':
      return 'https://global-pr.renaissance-go.com/launchcontrol'
    case 'localhost':
    case 'test':
    case 'demo':
    default:
      return 'https://global-dv.renaissance-golabs.com/launchcontrol'
  }
}

export const PATHS = {
  unversionedAPIUrl: mkSubdomainUrl('api'),
  imageAssetsUrl: 'https://images.freckle.com',
  prodAssetsUrl: 'https://classroom-assets.freckle.com',
  vendorAssetsUrl: 'https://vendor-assets.freckle.com',
  textAssetsUrl: CONTENT_URL,
  teacherDashUrl: mkSubdomainUrl('classroom'),
  studentClientUrl: mkSubdomainUrl('student'),
  schoolDashUrl: mkSubdomainUrl('school'),
  landingUrl,
  translationsUrl: 'https://translations.freckle.com',
  ttsUrl: 'https://tts.freckle.com',
  launchControlBaseUrl: mkLaunchControlBaseUrl()
}
